module.exports = __webpack_public_path__ + "static/media/cup-jour3.df59b10e.svg";